import { fieldAnatomy } from '@chakra-ui/react/anatomy';

export const fieldSlots = [...fieldAnatomy.keys(), 'tooltipIcon'];
